export const firebaseConfig = {
    apiKey: "AIzaSyDjfIWN3d01fu2P0jmI4cClPARV6wzOTpE",
    authDomain: "therapy-manager-82e60.firebaseapp.com",
    databaseURL: "https://therapy-manager-82e60-default-rtdb.firebaseio.com",
    projectId: "therapy-manager-82e60",
    storageBucket: "therapy-manager-82e60.appspot.com",
    messagingSenderId: "699975307473",
    appId: "1:699975307473:web:ac59bd65b7164fc3c3f5f0"
};